import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FacebookService, UIParams, UIResponse } from 'ngx-facebook';
import { FbService, ShareMessagesService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-fb-share',
  templateUrl: './fb-share.component.html',
  styleUrls: ['./fb-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FbShareComponent {

  @Input() public label;
  @Input() public count;
  @Input() public campaign_url;
  @Input() public utm_params;
  @Input() public backgroudColor = '#3b5998';
  @Input() public color = '#ffffff';
  @Input() public fundraiser;
  @Input() public position;
  @Input() public buttonType = 'square';
  @Input() public shareType = 'default';
  @Input() private userData;
  isLoading;

  shareUrl;
  utmData = {
    source: 'internal',
    medium: 'fbpageshare',
    campaign_name: ''
  };

  constructor(
    public fb: FacebookService,
    public shareMessagesService: ShareMessagesService,
    public utilService: UtilService,
    public fbService: FbService,
    public variablesService: VariablesService,
    private cdr: ChangeDetectorRef
  ) { }

  /**Face book share */
  async facebookShare() {
    this.isLoading = true;
    const fb_load = await this.fbService.scriptLoaderFB();
    this.isLoading = false;
    this.cdr.detectChanges();
    this.shareMessagesService.shareEvents('fb share', this.position);
    let url;
    let message;
    let pageName = 'fundraiser';
    if (this.variablesService.fundraiser.support_campaign) {
      pageName = 'supportfundraiser';
    }
    url = `${this.utilService.domain_details?.domain_url}/stories/${this.variablesService.fundraiser.custom_tag}`;
    this.utmData.campaign_name = this.variablesService.fundraiser.custom_tag;
    const params: UIParams = {
      href: `${this.shareMessagesService.getLinkWithUtmTags(url, this.utmData)}`,
      method: 'share',
      message: message || ''
    };
    this.fb.ui(params).then((res: UIResponse) => {
    }).catch((e: any) => {
    });
  }
}
